import RMSRebalanceAlertContainer from "./RMSRebalanceAlertContainer";
import RMSRebalanceAlertStore from "./RMSRebalanceAlertStore";

export default RMSRebalanceAlertStore(RMSRebalanceAlertContainer);